import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - DIALOG TITLE ||============================== //

export default function DialogTitle(theme: Theme) {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontWeight: 700,
          backgroundColor: theme.palette.background.default,

          padding: '8px 16px',
          '& .MuiTypography-root': {
            fontWeight: 500,
            fontSize: '1rem',
          }
        }
      }
    }
  };
}
